/** Order Sync — the standalone page: scope picker + the embeddable
 *  OrderSyncForm (which owns the capability-gated source modes, the advanced
 *  options and the launch). The setup wizard hosts the same form with a fixed
 *  scope and an injected launch path.
 */
import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { OrderSyncForm } from './OrderSyncForm';
import { SyncScopePicker, initialSyncScope, type SyncScope } from './SyncScopePicker';

export function OrderSyncPage() {
  const [scope, setScope] = useState<SyncScope>(initialSyncScope);

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Order Sync
      </Typography>

      <OrderSyncForm
        scope={scope}
        scopeSlot={
          <SyncScopePicker
            value={scope}
            onChange={setScope}
            requiredFeature="order_sync"
          />
        }
      />
    </Box>
  );
}
